// // Updated HeroSection styles using styled-components (styles.js)
// import styled from 'styled-components';
// import { animated } from 'react-spring';

// export const BackgroundContainer = styled.div`
//   width: 100%;
//   /* Add a top margin to push the hero section down below the nav */
//   margin-top: 80px;
//   margin-right: 0;
//   margin-bottom: 0;
//   margin-left: 0;
//   padding: 0;
//   position: relative;
  
//   /* Reversed gradient: top is white; bottom is deep blue (#06147a) */
//   background: linear-gradient(180deg,rgb(1, 7, 53) 0%,#ffffff 100%);
  
//   /* Original clip-path that (when unflipped) creates a semi-circle at the top */
//   clip-path: ellipse(150% 100% at 50% 100%);
  
//   /* Flip the container vertically so the curved edge moves to the bottom */
//   transform: scaleY(-1);

//   /* Ensure the pseudo-element border (if used) follows the flipped shape */
//   &::after {
//     content: "";
//     position: absolute;
//     top: 0;
//     left: 0;
//     width: 100%;
//     height: 100%;
//     border: 5px solidrgb(243, 243, 245);
//     clip-path: inherit;
//     pointer-events: none;
//     box-sizing: border-box;
//   }

//   /* Flip back the child content so it is displayed normally */
//   & > * {
//     transform: scaleY(-1);
//   }
//   @media (max-width: 768px) {
//     margin-top: 160px;
//   }
//   /* 1) Tablet‑portrait (769–1024px) */
//   @media (min-width: 769px) and (max-width: 1024px) {
//     margin-top: 100px;
//   }

//   /* 2) Tablet‑landscape (≤768px tall) */
//   @media (max-height: 768px) and (orientation: landscape) {
//     margin-top: 120px;
//   }

//   /* 3) Mobile‑portrait (≤480px wide) */
//   @media (max-width: 480px) {
//     margin-top: 110px;
//   }

//   /* 4) Mobile‑landscape (≤480px tall) */
//   @media (max-height: 480px) and (orientation: landscape) {
//     margin-top: 130px;
//   }

// `;

// export const TextSection = styled.section`
//   position: absolute;
//   top: 80%;         /* Adjust this value to move the text up or down */
//   left: 1%;
//   width: 100%;
//   text-align: center;
//   z-index: 2;
//   padding: 2rem 1rem;

//   h1 {
//     font-size: clamp(2.5rem, 5vw, 3rem);
//     margin-bottom: 0.5rem;
//     font-weight: bold;
//     font-family: var(--artdeco-reset-typography-font-family-sans);
//     color:rgb(1, 7, 53);
//     text-shadow: 1px 1px 5px rgba(6, 20, 122, 0.3);
//   }
//     @media (max-width: 768px) {
//     top: 85%;

//     h1{
//       font-size: clamp(1rem, 5vw, 3rem)
//     }
//   }
//   @media (max-width: 768px) {
//     top: 85%;
//     h1 { font-size: clamp(1rem, 5vw, 3rem); }
//   }

//   /* 1) Tablet‑portrait */
//   @media (min-width: 769px) and (max-width: 1024px) {
//     top: 75%;
//     h1 { font-size: clamp(2rem, 4vw, 2.5rem); }
//   }

//   /* 2) Tablet‑landscape */
//   @media (max-height: 768px) and (orientation: landscape) {
//     top: 70%;
//     h1 { font-size: clamp(1.8rem, 5vw, 2.2rem); }
//   }

//   /* 3) Mobile‑portrait */
//   @media (max-width: 480px) {
//     top: 73%;
//     h1 { font-size: clamp(1rem, 5vw, 2rem); }
//   }

//   /* 4) Mobile‑landscape */
//   @media (max-height: 480px) and (orientation: landscape) {
//     top: 73%;
//     h1 { font-size: clamp(1rem, 4vw, 1.5rem); }
//   }
// `;


// export const CarouselContainer = styled.div`
//   display: flex;
//   justify-content: center;
//   align-items: center;
//   width: 100%;
//   height: 80vh;
//   perspective: 2000px;
//   position: relative;
//   transform-style: preserve-3d;
//   margin-top: -40px;

//   @media (max-width: 768px) {
//     height: 50vh;
//     perspective: 1000px;
//   }
//   /* 1) Tablet‑portrait */
//   @media (min-width: 769px) and (max-width: 1024px) {
//     height: 70vh;
//   }
//   /* 2) Tablet‑landscape */
//   @media (max-height: 768px) and (orientation: landscape) {
//     height: 65vh;
//   }
//   /* 3) Mobile‑portrait */
//   @media (max-width: 480px) {
//     height: 55vh;
//   }
//   /* 4) Mobile‑landscape */
//   @media (max-height: 480px) and (orientation: landscape) {
//     height: 65vh;
//   }
// `;

// Updated HeroSection styles using styled-components (styles.js)
import styled, { css } from 'styled-components';

export const BackgroundContainer = styled.div`
  width: 100%;
  min-height: 80vh;
  background: transparent;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: center;
  position: relative;
  overflow: hidden;
  margin-bottom: 80px;

  @media (max-width: 1024px) {
    margin-bottom: 4px;
  }
`;

export const SlideWrapper = styled.div`
  width: 100%;
  max-width: 1400px;
  height: 620px;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  @media (max-width: 900px) {
    height: 480px;
  }
  @media (max-width: 600px) {
    height: 320px;
  }
`;

export const SlideContent = styled.div`
  position: absolute;
  top: 0; left: 0; width: 100%; height: 100%;
  display: flex;
  flex-direction: ${({ isTextLeft }) => (isTextLeft ? 'row' : 'row-reverse')};
  opacity: ${({ active }) => (active ? 1 : 0)};
  pointer-events: ${({ active }) => (active ? 'auto' : 'none')};
  transition: opacity 0.7s cubic-bezier(.4,0,.2,1);
  @media (max-width: 600px) {
    flex-direction: column !important;
    height: 500px;
    min-height: 500px;
    justify-content: flex-start;
    align-items: center;
  }
  @media (min-width: 768px) and (max-width: 1024px) {
    justify-content: center;
    padding: 0 40px;
  }
  @media (min-width: 901px) and (max-width: 1180px) {
    justify-content: center;
    padding: 0 40px;
  }
  @media (min-width: 1181px) and (max-width: 1368px) {
    justify-content: center;
    padding: 0 40px;
  }
  @media (min-width: 720px) and (max-width: 720px) {
    justify-content: center;
    padding: 0 40px;
  }
  @media (min-width: 1280px) and (max-width: 1280px) {
    justify-content: center;
    padding: 0 40px;
  }
`;

export const SlideText = styled.div`
  flex: 1 1 50%;
  max-width: 50%;
  background: rgba(255, 255, 255, 0);
  color: #fff;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 3rem 2.5rem;
  z-index: 2;
  backdrop-filter: blur(10px);
  @media (max-width: 900px) {
    padding: 0rem 1.2rem;
  }
  @media (max-width: 600px) {
    padding: 2rem 1rem;
    max-width: 100%;
    flex: 0 0 auto;
    width: 100%;
    min-height: 200px;
    order: 1;
    justify-content: center;
    align-items: center;
  }
`;

export const SlideHeading = styled.h2`
  font-size: 2.5rem;
  color: #fff;
  margin-bottom: 1.2rem;
  font-weight: 700;
  text-align: center;
  font-family: "Handel Gothic Std Regular", sans-serif;
  @media (max-width: 900px) {
    font-size: 2rem;
  }
  @media (max-width: 600px) {
    font-size: 1.8rem;
    margin-bottom: 1rem;
    line-height: 1.2;
  }
`;

export const SlideDescription = styled.p`
  font-size: 1.2rem;
  color: #e0e6f7;
  line-height: 1.6;
  @media (max-width: 900px) {
    font-size: 1rem;
  }
  @media (max-width: 600px) {
    font-size: 1rem;
    line-height: 1.4;
    text-align: center;
    margin: 0;
  }
`;

export const SlideImage = styled.img`
  flex: 1 1 50%;
  max-width: 50%;
  width: 100%;
  height: 85%;
  object-fit: cover;
  background: rgba(255, 255, 255, 0.05);
  margin: auto;
  display: block;
  border-radius: 100px;
  box-shadow: none;
  padding: 0;
  @media (max-width: 600px) {
    width: 90%;
    max-width: 90%;
    height: auto;
    max-height: 280px;
    object-fit: contain;
    display: block;
    margin: 0 auto;
    background: rgba(255, 255, 255, 0.05);
    padding: 0;
    order: 2;
    flex: 1 1 auto;
  }
`;

export const CarouselDots = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 2rem;
  gap: 0.7rem;
  span {
    display: inline-block;
    width: 12px;
    height: 12px;
    border-radius: 50%;
    background: #e0e0e0;
    cursor: pointer;
    transition: background 0.3s;
  }
  span.active {
    background: rgba(255, 255, 255, 0.8);
    box-shadow: 0 0 0 2px #000, 0 0 8px 2px rgba(255,255,255,0.3);
  }
`;

export const GlobeWrapper = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: clamp(400px, 45vw, 600px);
  height: clamp(400px, 45vw, 600px);
  z-index: 5;
  aspect-ratio: 1;
  border-radius: 50%;
  overflow: hidden;

  @media (max-width: 768px) {
    width: 300px;
    height: 300px;
  }
  
  /* 1) Tablet‑portrait: keep globe square, same clamp as desktop */
  @media (min-width: 769px) and (max-width: 1024px) {
    width: clamp(350px, 40vw, 450px);
    height: clamp(350px, 40vw, 450px);
  }

  /* 2) Tablet‑landscape */
  @media (max-height: 768px) and (orientation: landscape) {
    width: 280px;
    height: 280px;
  }
  /* 3) Mobile‑portrait */
  @media (max-width: 480px) {
    width: 200px;
    height: 200px;
  }
  /* 4) Mobile‑landscape */
  @media (max-height: 480px) and (orientation: landscape) {
    width: 200px;
    height: 200px;
  }
`;

export const Card = styled.div`
  width: clamp(250px, 25vw, 400px);
  height: clamp(350px, 40vh, 500px);
  position: absolute;
  background: #ffffff !important;
  box-shadow: 0 10px 20px rgba(6, 20, 122, 0.3);
  border-radius: 16px;
  overflow: hidden;
  cursor: pointer;
  transform-style: preserve-3d;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  border: 1px solid rgb(1, 7, 53);
  opacity: 1 !important;
  backdrop-filter: none;
  -webkit-backdrop-filter: none;

  &:hover {
    transform: scale(1.05);
    box-shadow: 0 15px 30px rgba(6, 20, 122, 0.5);
  }

  @media (max-width: 768px) {
    width: 200px;
    height: 300px;
  }
  
  /* 1) Tablet‑portrait */
  @media (min-width: 769px) and (max-width: 1024px) {
    width: clamp(220px, 22vw, 300px);
    height: clamp(320px, 35vh, 400px);
  }

  /* 2) Tablet‑landscape */
  @media (max-height: 768px) and (orientation: landscape) {
    width: clamp(180px, 18vw, 220px);
    height: clamp(260px, 30vh, 320px);
  }

  /* 3) Mobile‑portrait */
  @media (max-width: 480px) {
    width: 180px;
    height: 260px;
  }

  /* 4) Mobile‑landscape */
  @media (max-height: 480px) and (orientation: landscape) {
    width: 160px;
    height: 240px;
  }
`;

export const CardContent = styled.div`
  position: absolute;
  bottom: 0;
  width: 100%;
  background: linear-gradient(transparent, rgb(1, 7, 53));
  color: #fff;
  text-align: center;
  padding: 0.8rem;
  font-size: clamp(0.8rem, 1.2vw, 1rem);
  font-weight: 500;
  transition: padding 0.3s ease;
  opacity: 1 !important;
  backdrop-filter: none;
  -webkit-backdrop-filter: none;

  ${Card}:hover & {
    padding-bottom: 1rem;
  }
`;

export const CardImage = styled.img`
  width: 100%;
  height: auto;
  border-radius: 8px;
  object-fit: cover;
`;

